import { render, staticRenderFns } from "./DisplayOrderItems.vue?vue&type=template&id=52108f42&scoped=true"
import script from "./DisplayOrderItems.vue?vue&type=script&lang=js"
export * from "./DisplayOrderItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayOrderItems.vue?vue&type=style&index=0&id=52108f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52108f42",
  null
  
)

export default component.exports